import { render } from "./Cgu.vue?vue&type=template&id=1dd24c44&scoped=true"
import script from "./Cgu.vue?vue&type=script&lang=js"
export * from "./Cgu.vue?vue&type=script&lang=js"

import "./Cgu.vue?vue&type=style&index=0&id=1dd24c44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd24c44"]])

export default __exports__